import { MicrotaskProgress } from '@sketch-note/design-system/src';
import { TDescendant } from '@udecode/plate-core';
import cn from 'classnames';
import { useRouter } from 'next/router';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import useDebounce from 'react-use/lib/useDebounce';
import { API } from 'src/api';
import { BlockEditor } from 'src/components/BlockEditor';
import { EditorProvider } from 'src/features/collaborative-editor/components/EditorProvider';
// import { useSetStateBlockEditorValues } from 'src/shared/hooks';
import useSWR from 'swr';
const { useState, useRef } = React;

export const PublicDoc = ({ docId }: { docId: string }) => {
  const [microtasks, setMicrotasks] = useState({ total: 0, completed: 0 });
  const router = useRouter();
  // useSetStateBlockEditorValues({ docId: docId });

  const { data } = useSWR(
    docId ? `/files/public?id=${router.query.slug}&view=${docId}` : null,
    API.get
  );

  const firstCall = useRef(false);
  useDebounce(
    () => {
      const newValue = data?.data.data.document as TDescendant[];
      const microTasks = newValue?.filter((obj) => obj.type === 'micro_task');
      if (microTasks) {
        let total = 0;
        let completed = 0;
        microTasks.map((obj) => {
          if (obj.checked) {
            completed += 1;
          }
          total += 1;
        });

        setMicrotasks({ total, completed });
        firstCall.current = true;
      }
    },
    100,
    [data?.data.data.document, router.query.slug]
  );

  return (
    <div className=" bg-gray-100 overflow-hidden" style={{ height: 'calc(100vh - 100px)' }}>
      <div className="h-full overflow-auto">
        <div className={cn('max-w-1180 p-48 mx-auto my-30 rounded-md bg-white overflow-hidden')}>
          {data?.data.data.document && (
            <DndProvider backend={HTML5Backend}>
              <div className="w-full max-w-864 m-auto ">
                {microtasks.total > 0 ? (
                  <MicrotaskProgress current={microtasks.completed} total={microtasks.total} />
                ) : null}
              </div>
              <EditorProvider id={docId}>
                <BlockEditor isReadOnly value={data?.data.data.document} id={docId} />
              </EditorProvider>
            </DndProvider>
          )}
        </div>
      </div>
    </div>
  );
};
